/** CoStar.Api.ConsumerUserData.UserListingActivity.ActivityType */
export var ActivityType;
(function (ActivityType) {
    ActivityType[ActivityType["None"] = 0] = "None";
    ActivityType[ActivityType["Liked"] = 1] = "Liked";
    ActivityType[ActivityType["Disliked"] = 2] = "Disliked";
    ActivityType[ActivityType["PinViewed"] = 3] = "PinViewed";
})(ActivityType || (ActivityType = {}));
